var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a;
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { CircularProgress, Dialog, useMediaQuery } from "@mui/material";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getEstimateComplaintListUrl, getPostingTypeListUrl, getProxyProfileContactDetailsUrl } from "../../../api/url";
import { ReactComponent as CloseIcon } from '../../../assets/images/closeIcon.svg';
import { DynamicFormBuilderContainer } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { E_Channel_Name, LOCAL_STORAGE_KEYS } from "../../../constants";
import { getByIdAPI, getListAPI } from "../../../redux/crudSlice";
import { useAppSelector } from "../../../store/hooks";
import { getLocalStorageItem } from "../../../utils/storageHelper";
import robotoNormalFontBase64, { estimateBillingColumns, estimateColumns, formatAddressMultiline, formattedDate, formattedTime, robotoBoldFontBase64 } from "../../serviceEstimatePrint/services/entity";
import bajajCareAppQR from '../../../assets/images/bajajCareAppQR.png';
import dayjs from "dayjs";
import BajajLogo from '../../../assets/images/BajajLogo.png';
import Ktmlogo from '../../../assets/images/KTMLogo.png';
import TriumphLogo from '../../../assets/images/TriumphLogo.png';
import { getInsuranceProviderList } from "../../jobCardDetails/services/apiCalls";
import { getInstallbaseDetailsAPICall } from "../../jobCardDetails/services/utils";
import { getLabourColumnsAndHead, getPartsColumnsAndHead, OrganizationAddressAPIURL } from "../services/entity";
var Type_Enum = /*#__PURE__*/ function (Type_Enum) {
    Type_Enum["Parts"] = "Parts";
    Type_Enum["Labour"] = "Labour";
    return Type_Enum;
}(Type_Enum || {}); // Define enum for PostingTypeName
var PostingTypeNameEnum = /*#__PURE__*/ function (PostingTypeNameEnum) {
    PostingTypeNameEnum["Paid"] = "Paid";
    PostingTypeNameEnum["Expenses"] = "Expenses";
    PostingTypeNameEnum["Generate Claims"] = "Generate Claims";
    return PostingTypeNameEnum;
}(PostingTypeNameEnum || {});
var AppDetails = (_a = {},
    _a[E_Channel_Name.Triumph] = {
        Info: 'Please download “Triumph India” Mobile App on your smartphone and enjoy the digital experience.',
        OEM_Name: 'Triumph Motorcycle',
        LOGO: TriumphLogo
    },
    _a[E_Channel_Name.PB] = {
        Info: 'Please download “KTM India” / “Husqvarna Motorcycles” Mobile App on your smartphone and enjoy the digital experience.',
        OEM_Name: 'BAL',
        LOGO: Ktmlogo
    },
    _a[E_Channel_Name.CV] = {
        Info: '',
        OEM_Name: 'BAL',
        LOGO: BajajLogo
    },
    _a[E_Channel_Name.MC] = {
        Info: 'Please download “Bajaj Care” / “Bajaj Ride Connect” Mobile App on your smartphone and enjoy the digital experience.',
        OEM_Name: 'BAL',
        LOGO: BajajLogo
    },
    _a);
export var NewServiceEstimatePrint = function (_ref) {
    var _allJobs$additionalJo, _allJobs$additionalJo2, _allJobs$standardJobs, _allJobs$standardJobs2, _allJobs$periodicJobs, _allJobs$periodicJobs2, _allJobs$roadTestData, _documentDetailsGetBy, _triupmhProductCodes$, _AppDetails, _documentDetailsGetBy5, _totalByPostingType$P, _totalByPostingType$P2, _totalByPostingType$L, _totalByPostingType$L2, _totalByPostingType$P3, _totalByPostingType$P4, _totalByPostingType$L3, _totalByPostingType$L4, _totalByPostingType$P5, _totalByPostingType$P6, _totalByPostingType$L5, _totalByPostingType$L6, _totalByPostingType$P7, _totalByPostingType$P8, _totalByPostingType$L7, _totalByPostingType$L8, _totalByPostingType$P9, _totalByPostingType$P10, _totalByPostingType$L9, _totalByPostingType$L10, _totalByPostingType$P11, _totalByPostingType$P12, _totalByPostingType$L11, _totalByPostingType$L12;
    var data = _ref.data, onClose = _ref.onClose, allJobs = _ref.allJobs, inPersonImage = _ref.inPersonImage, open = _ref.open;
    var formattedJobs = {
        additionalJobs: {
            Part: allJobs === null || allJobs === void 0 || (_allJobs$additionalJo = allJobs.additionalJobs) === null || _allJobs$additionalJo === void 0 ? void 0 : _allJobs$additionalJo.filter(function (job) { return job.PartCode && !job.isExpanded; }),
            Labour: allJobs === null || allJobs === void 0 || (_allJobs$additionalJo2 = allJobs.additionalJobs) === null || _allJobs$additionalJo2 === void 0 ? void 0 : _allJobs$additionalJo2.filter(function (job) { return job.LabourCode && !job.isExpanded; })
        },
        standardJobs: {
            Part: allJobs === null || allJobs === void 0 || (_allJobs$standardJobs = allJobs.standardJobs) === null || _allJobs$standardJobs === void 0 ? void 0 : _allJobs$standardJobs.filter(function (job) { return job.PartCode && !job.isExpanded; }),
            Labour: allJobs === null || allJobs === void 0 || (_allJobs$standardJobs2 = allJobs.standardJobs) === null || _allJobs$standardJobs2 === void 0 ? void 0 : _allJobs$standardJobs2.filter(function (job) { return job.LabourCode && !job.isExpanded; })
        },
        periodicJobs: {
            Part: allJobs === null || allJobs === void 0 || (_allJobs$periodicJobs = allJobs.periodicJobs) === null || _allJobs$periodicJobs === void 0 ? void 0 : _allJobs$periodicJobs.filter(function (job) { return job.PartCode && !job.isExpanded; }),
            Labour: allJobs === null || allJobs === void 0 || (_allJobs$periodicJobs2 = allJobs.periodicJobs) === null || _allJobs$periodicJobs2 === void 0 ? void 0 : _allJobs$periodicJobs2.filter(function (job) { return job.LabourCode && !job.isExpanded; })
        },
        customerComplaints: allJobs === null || allJobs === void 0 || (_allJobs$roadTestData = allJobs.roadTestData) === null || _allJobs$roadTestData === void 0 ? void 0 : _allJobs$roadTestData.filter(function (job) { return !job.isExpanded; })
    };
    var _a = useState(__spreadArray(__spreadArray(__spreadArray([], (formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.additionalJobs.Part), true), (formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.standardJobs.Part), true), (formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.periodicJobs.Part), true)), allParts = _a[0], _setAllParts = _a[1];
    var _b = useState(__spreadArray(__spreadArray(__spreadArray([], (formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.additionalJobs.Labour), true), (formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.standardJobs.Labour), true), (formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.periodicJobs.Labour), true)), allLabours = _b[0], _setAllLabours = _b[1];
    var _c = useAppSelector(function (state) { return state.crud; }), documentDetailsGetById = _c.documentDetailsGetById, getCustomerInfo = _c.getCustomerInfo, signature = _c.signature, getContactDetailsData = _c.getContactDetailsData;
    var vehicleDetails = documentDetailsGetById === null || documentDetailsGetById === void 0 ? void 0 : documentDetailsGetById.data;
    var InsuranceDetails = (documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy = documentDetailsGetById.data) === null || _documentDetailsGetBy === void 0 ? void 0 : _documentDetailsGetBy.InsuranceDetails) || {};
    var customerData = getCustomerInfo === null || getCustomerInfo === void 0 ? void 0 : getCustomerInfo.data;
    var isMobile = useMediaQuery(function (theme) { return theme.breakpoints.down("sm"); });
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    var SELECTED_CHANNEL = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_CHANNEL);
    var channelName = SELECTED_CHANNEL === null || SELECTED_CHANNEL === void 0 ? void 0 : SELECTED_CHANNEL.ChannelName;
    var triupmhProductCodes = getLocalStorageItem(LOCAL_STORAGE_KEYS.TRNTBikeProductCode);
    // Split the Value string into an array and trim whitespace
    var productCodesArray = triupmhProductCodes === null || triupmhProductCodes === void 0 || (_triupmhProductCodes$ = triupmhProductCodes.Value) === null || _triupmhProductCodes$ === void 0 ? void 0 : _triupmhProductCodes$.split(',').map(function (code) { return code.trim(); });
    var logo = ((_AppDetails = AppDetails[channelName]) === null || _AppDetails === void 0 ? void 0 : _AppDetails.LOGO) || BajajLogo;
    var _d = useState(true), isPrintLoading = _d[0], setIsPrintLoading = _d[1];
    var _e = useState([]), customerComplaintList = _e[0], setCustomerComplaintList = _e[1];
    var _f = useState(''), providerName = _f[0], setProviderName = _f[1];
    var crud = useAppSelector(function (state) { return state.crud; });
    var dispatch = useDispatch();
    var _g = useState(""), qrBase64 = _g[0], setQrBase64 = _g[1];
    var _h = useState(''), logoBase64 = _h[0], setLogoBase64 = _h[1];
    var _j = useState({}), insuranceProviderAddress = _j[0], setInsuranceProviderAddress = _j[1];
    var _k = useState({
        Part: {
            Paid: 0,
            Expenses: 0,
            "Generate Claims": 0
        },
        Labour: {
            Paid: 0,
            Expenses: 0,
            "Generate Claims": 0
        }
    }), totalByPostingType = _k[0], setTotalByPostingType = _k[1];
    var organizationAddress;
    if (selectedBranch !== null && selectedBranch !== void 0 && selectedBranch.OrganizationAddress) {
        organizationAddress = formatAddressMultiline(selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationAddress);
    }
    // useEffect(() => {
    //     loadBase64FromImportedImage(bajajCareAppQR).then(setQrBase64);
    //     fetchInsuranceProviders(InsuranceDetails?.InsuranceProviderId)
    //     getProductCategoryAPICall(vehicleDetails?.ProductId)
    //     getCustomerComplaintPriceAPICall(documentDetailsGetById?.data?.EstimateId)
    //     getPostingTypeAPICall()
    //     getContactDetails();
    //     fetchInsuranceProviderDetails(InsuranceDetails?.InsuranceProviderId)
    //     setIsPrintLoading(false)
    // }, []);
    useEffect(function () {
        var loadAllData = function () { return __awaiter(void 0, void 0, void 0, function () {
            var _documentDetailsGetBy2, promises, qrBase64Promise, insuranceProvidersPromise, complaintPricePromise, postingTypePromise, contactDetailsPromise, insuranceProviderDetailsPromise, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        promises = [];
                        qrBase64Promise = loadBase64FromImportedImage(bajajCareAppQR).then(setQrBase64);
                        promises.push(qrBase64Promise);
                        insuranceProvidersPromise = fetchInsuranceProviders(InsuranceDetails === null || InsuranceDetails === void 0 ? void 0 : InsuranceDetails.InsuranceProviderId);
                        promises.push(insuranceProvidersPromise);
                        complaintPricePromise = getCustomerComplaintPriceAPICall(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy2 = documentDetailsGetById.data) === null || _documentDetailsGetBy2 === void 0 ? void 0 : _documentDetailsGetBy2.EstimateId);
                        promises.push(complaintPricePromise);
                        postingTypePromise = getPostingTypeAPICall();
                        promises.push(postingTypePromise);
                        contactDetailsPromise = getContactDetails();
                        promises.push(contactDetailsPromise);
                        insuranceProviderDetailsPromise = fetchInsuranceProviderDetails(InsuranceDetails === null || InsuranceDetails === void 0 ? void 0 : InsuranceDetails.InsuranceProviderId);
                        promises.push(insuranceProviderDetailsPromise);
                        // Wait for all to complete
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        // Wait for all to complete
                        _a.sent();
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error("Error loading data:", error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsPrintLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        loadAllData();
    }, []);
    useEffect(function () {
        loadBase64FromImportedImage(logo).then(setLogoBase64);
    }, [logo]);
    useEffect(function () {
        var _documentDetailsGetBy3, _documentDetailsGetBy4;
        if (documentDetailsGetById !== null && documentDetailsGetById !== void 0 && (_documentDetailsGetBy3 = documentDetailsGetById.data) !== null && _documentDetailsGetBy3 !== void 0 && _documentDetailsGetBy3.InstallBaseId)
            getInstallbaseDetailsAPICall(documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy4 = documentDetailsGetById.data) === null || _documentDetailsGetBy4 === void 0 ? void 0 : _documentDetailsGetBy4.InstallBaseId);
    }, [documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy5 = documentDetailsGetById.data) === null || _documentDetailsGetBy5 === void 0 ? void 0 : _documentDetailsGetBy5.InstallBaseId]);
    var getContactDetails = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getByIdAPI({
                        key: "getContactDetailsData",
                        url: getProxyProfileContactDetailsUrl
                    }))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    }); };
    console.log('getContactDetailsData', getContactDetailsData);
    var taxMode = null;
    var detectTaxMode = function (items) {
        for (var _i = 0, items_1 = items; _i < items_1.length; _i++) {
            var item = items_1[_i];
            var _item$SelectedPriceDe, _item$Price;
            var taxes = (item === null || item === void 0 || (_item$SelectedPriceDe = item.SelectedPriceDetails) === null || _item$SelectedPriceDe === void 0 ? void 0 : _item$SelectedPriceDe.Taxes) || (item === null || item === void 0 || (_item$Price = item.Price) === null || _item$Price === void 0 || (_item$Price = _item$Price[0]) === null || _item$Price === void 0 ? void 0 : _item$Price.Taxes) || [];
            for (var _a = 0, taxes_1 = taxes; _a < taxes_1.length; _a++) {
                var tax = taxes_1[_a];
                if ((tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === "IGST")
                    return 'IGST';
                if ((tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === "SGST" || (tax === null || tax === void 0 ? void 0 : tax.TaxComponentName) === "CGST")
                    return 'SGST_CGST';
            }
        }
        return null;
    };
    var labourTaxMode = detectTaxMode(allLabours);
    var partTaxMode = detectTaxMode(allParts);
    if (labourTaxMode === 'IGST' || partTaxMode === 'IGST') {
        taxMode = 'IGST';
    }
    else if (labourTaxMode === 'SGST_CGST' || partTaxMode === 'SGST_CGST') {
        taxMode = 'SGST_CGST';
    }
    var truncateAddress = function (address) {
        var maxLength = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 100;
        if ((address === null || address === void 0 ? void 0 : address.length) <= maxLength)
            return address;
        return (address === null || address === void 0 ? void 0 : address.slice(0, maxLength - 3).trimEnd()) + '...';
    };
    var loadBase64FromImportedImage = function (imageUrl) {
        return fetch(imageUrl).then(function (res) { return res.blob(); }).then(function (blob) { return new Promise(function (resolve, reject) {
            var reader = new FileReader();
            reader.onloadend = function () { return resolve(reader.result); };
            reader.onerror = function () { return reject('Error reading blob'); };
            reader.readAsDataURL(blob);
        }); });
    };
    var extractFormattedPartAndLabours = function (items, type) {
        var getFormattedData = function (item, type) {
            var price = (item === null || item === void 0 ? void 0 : item.SelectedPriceDetails) || {};
            var taxes = (price === null || price === void 0 ? void 0 : price.Taxes) || [];
            var SGST = taxes.find(function (tax) { return tax.TaxComponentName === "SGST"; });
            var CGST = taxes.find(function (tax) { return tax.TaxComponentName === "CGST"; });
            var IGST = taxes.find(function (tax) { return tax.TaxComponentName === "IGST"; });
            var commonFields = {
                Rate: ((price === null || price === void 0 ? void 0 : price.Rate) || 0).toFixed(2),
                Quantity: (item === null || item === void 0 ? void 0 : item.Quantity) || 0,
                TotaldiscountAmount: 0..toFixed(2),
                TaxableAmount: ((price === null || price === void 0 ? void 0 : price.TaxableAmount) || 0).toFixed(2),
                SGSTPercentage: (SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentPercentage) || 0,
                SGSTAmount: ((SGST === null || SGST === void 0 ? void 0 : SGST.TaxComponentAmount) || 0).toFixed(2),
                CGSTPercentage: (CGST === null || CGST === void 0 ? void 0 : CGST.TaxComponentPercentage) || 0,
                CGSTAmount: ((CGST === null || CGST === void 0 ? void 0 : CGST.TaxComponentAmount) || 0).toFixed(2),
                IGSTPercentage: (IGST === null || IGST === void 0 ? void 0 : IGST.TaxComponentPercentage) || 0,
                IGSTAmount: ((IGST === null || IGST === void 0 ? void 0 : IGST.TaxComponentAmount) || 0).toFixed(2),
                Amount: ((price === null || price === void 0 ? void 0 : price.Amount) || 0).toFixed(2)
            };
            if (type === Type_Enum.Parts) {
                return _objectSpread(_objectSpread({}, commonFields), {}, {
                    partCodeName: "".concat((item === null || item === void 0 ? void 0 : item.PartName) || "", " (").concat((item === null || item === void 0 ? void 0 : item.PartCode) || "", ")"),
                    HSNCode: (price === null || price === void 0 ? void 0 : price.HSNSACCode) || "",
                    UnitOfMeasurementName: (item === null || item === void 0 ? void 0 : item.UnitOfMeasurementName) || ""
                });
            }
            else {
                return _objectSpread(_objectSpread({}, commonFields), {}, {
                    labourCodeName: "".concat(item === null || item === void 0 ? void 0 : item.LabourName, " (").concat(item === null || item === void 0 ? void 0 : item.LabourCode, ")"),
                    HSNSACCode: (price === null || price === void 0 ? void 0 : price.HSNSACCode) || "",
                    Description: item.IsAutoFill ? item.Description : ""
                });
            }
        };
        var allItems = [];
        if (Array.isArray(items)) {
            items.forEach(function (item) {
                allItems.push(getFormattedData(item, type));
            });
        }
        return allItems;
    };
    var fetchInsuranceProviders = function (InsuranceProviderId) { return __awaiter(void 0, void 0, void 0, function () {
        var response, foundItem, name;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getInsuranceProviderList({})];
                case 1:
                    response = _a.sent();
                    foundItem = Array.isArray(response.data) ? response.data.find(function (item) { return item.id === InsuranceProviderId; }) : null;
                    name = foundItem ? foundItem.Name : undefined;
                    setProviderName(name);
                    return [2 /*return*/];
            }
        });
    }); };
    var fetchInsuranceProviderDetails = function (OrganizationId) { return __awaiter(void 0, void 0, void 0, function () {
        var _res$payload, res;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, dispatch(getListAPI({
                        key: 'InsuranceProviderDetails',
                        url: OrganizationAddressAPIURL,
                        request: {
                            OrganizationId: OrganizationId
                        }
                    }))];
                case 1:
                    res = _a.sent();
                    setInsuranceProviderAddress((res === null || res === void 0 || (_res$payload = res.payload) === null || _res$payload === void 0 || (_res$payload = _res$payload.value) === null || _res$payload === void 0 ? void 0 : _res$payload.data) || {});
                    return [2 /*return*/];
            }
        });
    }); };
    var getPostingTypeAPICall = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, serviceTypeIds, request, result, repairTypes, sumAmounts_1, partTotals_1, labourTotals_1, resultTotals;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    serviceTypeIds = Array.from(new Set(__spreadArray(__spreadArray([], allParts, true), allLabours, true).map(function (job) { return job.ServiceTypeId; }).filter(Boolean)));
                    request = {
                        ServiceTypeId: serviceTypeIds
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "postingTypeById",
                            url: getPostingTypeListUrl,
                            request: request
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && (_result$payload = _result$payload.value) !== null && _result$payload !== void 0 && _result$payload.data && Array.isArray(result.payload.value.data)) {
                        repairTypes = result.payload.value.data;
                        sumAmounts_1 = function (items, serviceTypeId) {
                            return items.filter(function (item) { return item.ServiceTypeId === serviceTypeId; }).reduce(function (sum, item) {
                                var _item$SelectedPriceDe2;
                                return sum + Number((item === null || item === void 0 || (_item$SelectedPriceDe2 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe2 === void 0 ? void 0 : _item$SelectedPriceDe2.Amount) || 0);
                            }, 0);
                        };
                        partTotals_1 = {};
                        labourTotals_1 = {};
                        if (Array.isArray(repairTypes)) {
                            repairTypes.forEach(function (rt) {
                                var postingType = rt.PostingTypeName;
                                var repairTypeId = rt.RepairTypeId;
                                var partSum = sumAmounts_1(allParts, repairTypeId);
                                var labourSum = sumAmounts_1(allLabours, repairTypeId);
                                partTotals_1[postingType] = (partTotals_1[postingType] || 0) + partSum;
                                labourTotals_1[postingType] = (labourTotals_1[postingType] || 0) + labourSum;
                            });
                        }
                        resultTotals = {
                            Part: partTotals_1,
                            Labour: labourTotals_1
                        };
                        setTotalByPostingType(resultTotals);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getCustomerComplaintPriceAPICall = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload2, customerRequest, result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    customerRequest = {
                        EstimateId: id
                    };
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            url: getEstimateComplaintListUrl,
                            request: customerRequest
                        }))];
                case 1:
                    result = _a.sent();
                    setCustomerComplaintList(result === null || result === void 0 || (_result$payload2 = result.payload) === null || _result$payload2 === void 0 || (_result$payload2 = _result$payload2.data) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.CustomerVoice);
                    return [2 /*return*/];
            }
        });
    }); };
    var renderValue = function (value) {
        if (value)
            return value;
        return '';
    };
    var calculateTotalAmountForJobs = function (jobs, type) {
        var _jobs$type;
        return (jobs === null || jobs === void 0 || (_jobs$type = jobs[type]) === null || _jobs$type === void 0 ? void 0 : _jobs$type.reduce(function (sum, item) {
            var _item$SelectedPriceDe3;
            return sum + ((item === null || item === void 0 || (_item$SelectedPriceDe3 = item.SelectedPriceDetails) === null || _item$SelectedPriceDe3 === void 0 ? void 0 : _item$SelectedPriceDe3.Amount) || 0);
        }, 0)) || 0;
    };
    // Convert string values to numbers before calculations
    var calculateTotalForSection = function (partAmount, labourAmount) {
        var partNum = parseFloat(partAmount) || 0;
        var labourNum = parseFloat(labourAmount) || 0;
        return (partNum + labourNum).toFixed(2);
    };
    var totalPartsAmountForStandardJobs = calculateTotalAmountForJobs(formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.standardJobs, 'Part').toFixed(2);
    var totalLabourAmountForStandardJobs = calculateTotalAmountForJobs(formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.standardJobs, 'Labour').toFixed(2);
    var totalPartsAmountForAdditionalJobs = calculateTotalAmountForJobs(formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.additionalJobs, 'Part').toFixed(2);
    var totalLabourAmountForAdditionalJobs = calculateTotalAmountForJobs(formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.additionalJobs, 'Labour').toFixed(2);
    var totalPartsAmountForPeriodicJobs = calculateTotalAmountForJobs(formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.periodicJobs, 'Part').toFixed(2);
    var totalLabourAmountForPeriodicJobs = calculateTotalAmountForJobs(formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.periodicJobs, 'Labour').toFixed(2);
    // Customer Complaints
    var customerComplaints = formattedJobs === null || formattedJobs === void 0 ? void 0 : formattedJobs.customerComplaints;
    var totalPartPrice = customerComplaints === null || customerComplaints === void 0 ? void 0 : customerComplaints.reduce(function (sum, item) {
        return sum + Number((item === null || item === void 0 ? void 0 : item.PartPrice) || 0);
    }, 0);
    var totalLabourPrice = customerComplaints === null || customerComplaints === void 0 ? void 0 : customerComplaints.reduce(function (sum, item) {
        return sum + Number((item === null || item === void 0 ? void 0 : item.LabourPrice) || 0);
    }, 0);
    var estimationSummary = [{
            Section: "Periodic Services",
            totalPartAmount: totalPartsAmountForPeriodicJobs,
            totalLabourAmount: totalLabourAmountForPeriodicJobs,
            total: calculateTotalForSection(totalPartsAmountForPeriodicJobs, totalLabourAmountForPeriodicJobs)
        }, {
            Section: "Customer Complaints",
            totalPartAmount: totalPartPrice === null || totalPartPrice === void 0 ? void 0 : totalPartPrice.toFixed(2),
            totalLabourAmount: totalLabourPrice === null || totalLabourPrice === void 0 ? void 0 : totalLabourPrice.toFixed(2),
            total: (totalPartPrice + totalLabourPrice).toFixed(2)
        }, {
            Section: "Standard Jobs",
            totalPartAmount: totalPartsAmountForStandardJobs,
            totalLabourAmount: totalLabourAmountForStandardJobs,
            total: calculateTotalForSection(totalPartsAmountForStandardJobs, totalLabourAmountForStandardJobs)
        }, {
            Section: "Additional Jobs",
            totalPartAmount: totalPartsAmountForAdditionalJobs,
            totalLabourAmount: totalLabourAmountForAdditionalJobs,
            total: calculateTotalForSection(totalPartsAmountForAdditionalJobs, totalLabourAmountForAdditionalJobs)
        }];
    var estimateBillingSummary = [{
            Section: "Paid",
            totalPartAmount: (((_totalByPostingType$P = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$P2 = totalByPostingType.Part) === null || _totalByPostingType$P2 === void 0 ? void 0 : _totalByPostingType$P2.Paid) !== null && _totalByPostingType$P !== void 0 ? _totalByPostingType$P : 0) + (totalPartPrice !== null && totalPartPrice !== void 0 ? totalPartPrice : 0)).toFixed(2),
            totalLabourAmount: (((_totalByPostingType$L = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$L2 = totalByPostingType.Labour) === null || _totalByPostingType$L2 === void 0 ? void 0 : _totalByPostingType$L2.Paid) !== null && _totalByPostingType$L !== void 0 ? _totalByPostingType$L : 0) + (totalLabourPrice !== null && totalLabourPrice !== void 0 ? totalLabourPrice : 0)).toFixed(2),
            total: (((_totalByPostingType$P3 = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$P4 = totalByPostingType.Part) === null || _totalByPostingType$P4 === void 0 ? void 0 : _totalByPostingType$P4.Paid) !== null && _totalByPostingType$P3 !== void 0 ? _totalByPostingType$P3 : 0) + ((_totalByPostingType$L3 = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$L4 = totalByPostingType.Labour) === null || _totalByPostingType$L4 === void 0 ? void 0 : _totalByPostingType$L4.Paid) !== null && _totalByPostingType$L3 !== void 0 ? _totalByPostingType$L3 : 0) + (totalPartPrice !== null && totalPartPrice !== void 0 ? totalPartPrice : 0) + (totalLabourPrice !== null && totalLabourPrice !== void 0 ? totalLabourPrice : 0)).toFixed(2)
        }, {
            Section: "FOC",
            totalPartAmount: ((_totalByPostingType$P5 = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$P6 = totalByPostingType.Part) === null || _totalByPostingType$P6 === void 0 ? void 0 : _totalByPostingType$P6.Expenses) !== null && _totalByPostingType$P5 !== void 0 ? _totalByPostingType$P5 : 0).toFixed(2),
            totalLabourAmount: ((_totalByPostingType$L5 = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$L6 = totalByPostingType.Labour) === null || _totalByPostingType$L6 === void 0 ? void 0 : _totalByPostingType$L6.Expenses) !== null && _totalByPostingType$L5 !== void 0 ? _totalByPostingType$L5 : 0).toFixed(2),
            total: (((_totalByPostingType$P7 = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$P8 = totalByPostingType.Part) === null || _totalByPostingType$P8 === void 0 ? void 0 : _totalByPostingType$P8.Expenses) !== null && _totalByPostingType$P7 !== void 0 ? _totalByPostingType$P7 : 0) + ((_totalByPostingType$L7 = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$L8 = totalByPostingType.Labour) === null || _totalByPostingType$L8 === void 0 ? void 0 : _totalByPostingType$L8.Expenses) !== null && _totalByPostingType$L7 !== void 0 ? _totalByPostingType$L7 : 0)).toFixed(2)
        }, {
            Section: "Warranty",
            totalPartAmount: ((_totalByPostingType$P9 = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$P10 = totalByPostingType.Part) === null || _totalByPostingType$P10 === void 0 ? void 0 : _totalByPostingType$P10['Generate Claims']) !== null && _totalByPostingType$P9 !== void 0 ? _totalByPostingType$P9 : 0).toFixed(2),
            totalLabourAmount: ((_totalByPostingType$L9 = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$L10 = totalByPostingType.Labour) === null || _totalByPostingType$L10 === void 0 ? void 0 : _totalByPostingType$L10['Generate Claims']) !== null && _totalByPostingType$L9 !== void 0 ? _totalByPostingType$L9 : 0).toFixed(2),
            total: (((_totalByPostingType$P11 = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$P12 = totalByPostingType.Part) === null || _totalByPostingType$P12 === void 0 ? void 0 : _totalByPostingType$P12['Generate Claims']) !== null && _totalByPostingType$P11 !== void 0 ? _totalByPostingType$P11 : 0) + ((_totalByPostingType$L11 = totalByPostingType === null || totalByPostingType === void 0 || (_totalByPostingType$L12 = totalByPostingType.Labour) === null || _totalByPostingType$L12 === void 0 ? void 0 : _totalByPostingType$L12['Generate Claims']) !== null && _totalByPostingType$L11 !== void 0 ? _totalByPostingType$L11 : 0)).toFixed(2)
        }];
    var generatePDF = function () {
        var arguments_1 = arguments;
        return __awaiter(this, void 0, void 0, function () {
            var _lastAutoTable, mode, doc, margin, otherPageStartY, pageWidth, pageHeight, currentPage, headerHeight, footerHeight, leftMargin, tableBottomY, renderDetails, addHeader, customerVoice, customerVoiceStartY, afterCustomerVoiceY, totalPagesExp, addFooter, renderUnifiedTable, renderTable, finalY, _a, labourColumns, labourGroupedHead, labourTableY, _b, partsColumns, partGroupedHead, partTableY, availableSpace, startY, estimateTableY, totalPages, i, isMobile_1, pdfBlob, blobUrl, newWindow, iframe_1;
            return __generator(this, function (_c) {
                mode = arguments_1.length > 0 && arguments_1[0] !== undefined ? arguments_1[0] : 'download';
                doc = new jsPDF();
                margin = 7;
                otherPageStartY = 55;
                pageWidth = doc.internal.pageSize.getWidth();
                pageHeight = doc.internal.pageSize.height;
                currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                headerHeight = currentPage === 1 ? 60 : 0;
                footerHeight = 35;
                leftMargin = 7;
                tableBottomY = 0;
                doc.addFileToVFS("Roboto-Regular.ttf", robotoNormalFontBase64);
                doc.addFont("Roboto-Regular.ttf", "Roboto", "normal");
                doc.setFont("Roboto");
                doc.addFileToVFS('Roboto-Bold.ttf', robotoBoldFontBase64);
                doc.addFont("Roboto-Bold.ttf", "Roboto", "bold");
                doc.setFont("Roboto");
                renderDetails = function (title, details, startX, startY) {
                    var valueOffset = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 30;
                    var keyWidth = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 20;
                    var valueWidth = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : 30;
                    var lineHeight = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : 4;
                    var currentY = startY + 2;
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.text(title || '', startX, startY + 1);
                    if (Array.isArray(details)) {
                        details === null || details === void 0 || details.forEach(function (_ref2) {
                            var label = _ref2[0], value = _ref2[1];
                            currentY += lineHeight;
                            doc.setFontSize(7);
                            doc.setFont("helvetica", "bold");
                            doc.text(label || '', startX, currentY, {
                                maxWidth: keyWidth
                            });
                            doc.setFontSize(7);
                            doc.setFont("helvetica", "normal");
                            var wrappedText = doc.splitTextToSize(value, valueWidth);
                            // doc.text(": " + value, startX + valueOffset, currentY, { maxWidth: valueWidth });
                            // currentY += (wrappedText.length - 1) * lineHeight;
                            doc.text(": ".concat(wrappedText[0]), startX + valueOffset, currentY);
                            // Calculate width of ": " to use as left padding on next lines
                            var colonWidth = doc.getTextWidth(": ");
                            // Draw remaining lines with left padding to align properly
                            for (var i = 1; i < wrappedText.length; i++) {
                                currentY += 3;
                                doc.text(" ".repeat(1), startX + valueOffset, currentY); // Optional spacing, not strictly needed
                                doc.text(wrappedText[i] || '', startX + valueOffset + colonWidth, currentY);
                            }
                        });
                    }
                    return currentY;
                };
                addHeader = function (doc) {
                    var _customerData$Person, _customerData$Person2, _customerData$PersonC, _customerData$PersonC2, _customerData$Address, _customerData$Address2, _customerData$Address3, _customerData$Address4, _customerData$Address5, _customerData$Address6, _customerData$Address7, _customerData$Address8, _customerData$Person3;
                    var pageWidth = doc.internal.pageSize.getWidth();
                    var lineHeight = 4;
                    var logoWidth = 22;
                    var logoHeight = channelName === E_Channel_Name.Triumph ? 6 : 10;
                    var logoX = margin;
                    var logoY = margin;
                    doc.addImage(logoBase64, "PNG", logoX, logoY + 10, logoWidth, logoHeight);
                    // === Title (Centered) ===
                    var titleY = logoY + 2;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(12);
                    doc.text("SERVICE ESTIMATE", pageWidth / 2, titleY, {
                        align: "center"
                    });
                    // Add gap below title
                    var sectionStartY = titleY + 6;
                    // === Dealer Address (Left) ===
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    var leftX = logoX + logoWidth + 5;
                    var leftY = sectionStartY;
                    doc.text("DEALER ADDRESS :", leftX, leftY);
                    // leftY += lineHeight;
                    // doc.setFont("helvetica", "bold");
                    // doc.text("AMIN AUTOMOBILES(10000)", leftX, leftY);
                    // doc.setFont("helvetica", "normal");
                    // leftY += lineHeight;
                    // doc.text("Amin Automobiles, Nr. Old rupali,", leftX, leftY);
                    // leftY += lineHeight;
                    // doc.text("Laladarwaja, Ahmedabad, 380001.", leftX, leftY);
                    // leftY += lineHeight;
                    // doc.text("Gujarat [State Code : 24]", leftX, leftY);
                    // leftY += lineHeight;
                    // doc.text("GSTIN : 24AAFFA6660R1ZY", leftX, leftY);
                    doc.setFontSize(7);
                    doc.setFont("helvetica", "bold");
                    // doc.text(selectedBranch?.OrganizationName ? selectedBranch?.OrganizationName : '', leftX, leftY + 3, { maxWidth: 45 });
                    var orgNameLines = doc.splitTextToSize((selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationName) || '', 45);
                    var orgNameY = leftY + 5.5;
                    doc.text(orgNameLines, leftX, leftY + 5.5);
                    doc.setFont("helvetica", "normal");
                    // doc.text(truncateAddress(organizationAddress) ?? '', leftX, leftY + 7, { maxWidth: 45 })
                    var addressStartY = orgNameY + orgNameLines.length * 3;
                    var addressLines = doc.splitTextToSize(organizationAddress || '', 45);
                    doc.text(addressLines, leftX, addressStartY);
                    // doc.text(organizationAddress || '', leftX, leftY + 7, { maxWidth: 45 })
                    // const addressLines = doc.splitTextToSize(organizationAddress || '', 45);
                    // doc.text(addressLines || '', leftX, leftY + 7);
                    var gstY = addressStartY + addressLines.length * 3 + 1;
                    // const gstY = leftY + 7 + addressLines.length * 3; // Adjust line height (3) as needed
                    doc.setFont("helvetica", "bold");
                    doc.text("GSTIN No.  :", leftX, gstY);
                    doc.setFont("helvetica", "normal");
                    doc.text("".concat((selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.TaxId) || ''), leftX + 15, gstY);
                    // === Branch Address (Center) ===
                    var centerX = pageWidth / 2 - 20;
                    var centerY = sectionStartY;
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    doc.text("BRANCH ADDRESS :", centerX, centerY);
                    doc.setFont("helvetica", "bold");
                    // doc.text(selectedBranch?.OrganizationName ? selectedBranch?.OrganizationName : '', centerX, centerY + 3);
                    var branchNameLines = doc.splitTextToSize((selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationName) || '', 45);
                    var branchNameY = centerY + 5.5;
                    doc.text(branchNameLines, centerX, branchNameY);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(7);
                    // doc.text(truncateAddress(organizationAddress) ?? '', centerX, centerY + 7, { maxWidth: 45 })
                    // doc.text(organizationAddress || '', centerX, centerY + 7, { maxWidth: 45 })
                    var branchAddressStartY = branchNameY + branchNameLines.length * 3;
                    var branchAddressLines = doc.splitTextToSize(organizationAddress || '', 45);
                    doc.text(branchAddressLines, centerX, branchAddressStartY);
                    var rightX = pageWidth - margin - 50;
                    var rightY = sectionStartY;
                    var customerY = renderDetails("Customer Details:", [["Customer Name", "".concat((customerData === null || customerData === void 0 || (_customerData$Person = customerData.Person) === null || _customerData$Person === void 0 ? void 0 : _customerData$Person.GivenName) || '', " ").concat((customerData === null || customerData === void 0 || (_customerData$Person2 = customerData.Person) === null || _customerData$Person2 === void 0 ? void 0 : _customerData$Person2.FamilyName) || '').trim()], ["Mobile No.", (customerData === null || customerData === void 0 || (_customerData$PersonC = customerData.PersonContact) === null || _customerData$PersonC === void 0 || (_customerData$PersonC = _customerData$PersonC.find(function (contact) { return (contact === null || contact === void 0 ? void 0 : contact.ContactType) === "Primary"; })) === null || _customerData$PersonC === void 0 ? void 0 : _customerData$PersonC.MobileNumber) || (customerData === null || customerData === void 0 || (_customerData$PersonC2 = customerData.PersonContact) === null || _customerData$PersonC2 === void 0 || (_customerData$PersonC2 = _customerData$PersonC2.find(function (contact) { return (contact === null || contact === void 0 ? void 0 : contact.ContactType) === "Secondary"; })) === null || _customerData$PersonC2 === void 0 ? void 0 : _customerData$PersonC2.MobileNumber) || ''], ["Address", [customerData === null || customerData === void 0 || (_customerData$Address = customerData.Address) === null || _customerData$Address === void 0 || (_customerData$Address = _customerData$Address[0]) === null || _customerData$Address === void 0 ? void 0 : _customerData$Address.Address1, customerData === null || customerData === void 0 || (_customerData$Address2 = customerData.Address) === null || _customerData$Address2 === void 0 || (_customerData$Address2 = _customerData$Address2[0]) === null || _customerData$Address2 === void 0 ? void 0 : _customerData$Address2.Address2, customerData === null || customerData === void 0 || (_customerData$Address3 = customerData.Address) === null || _customerData$Address3 === void 0 || (_customerData$Address3 = _customerData$Address3[0]) === null || _customerData$Address3 === void 0 ? void 0 : _customerData$Address3.Address3, customerData === null || customerData === void 0 || (_customerData$Address4 = customerData.Address) === null || _customerData$Address4 === void 0 || (_customerData$Address4 = _customerData$Address4[0]) === null || _customerData$Address4 === void 0 ? void 0 : _customerData$Address4.Address4, customerData === null || customerData === void 0 || (_customerData$Address5 = customerData.Address) === null || _customerData$Address5 === void 0 || (_customerData$Address5 = _customerData$Address5[0]) === null || _customerData$Address5 === void 0 ? void 0 : _customerData$Address5.CityName, customerData === null || customerData === void 0 || (_customerData$Address6 = customerData.Address) === null || _customerData$Address6 === void 0 || (_customerData$Address6 = _customerData$Address6[0]) === null || _customerData$Address6 === void 0 ? void 0 : _customerData$Address6.StateName, customerData === null || customerData === void 0 || (_customerData$Address7 = customerData.Address) === null || _customerData$Address7 === void 0 || (_customerData$Address7 = _customerData$Address7[0]) === null || _customerData$Address7 === void 0 ? void 0 : _customerData$Address7.Zip, customerData === null || customerData === void 0 || (_customerData$Address8 = customerData.Address) === null || _customerData$Address8 === void 0 || (_customerData$Address8 = _customerData$Address8[0]) === null || _customerData$Address8 === void 0 ? void 0 : _customerData$Address8.CountryName].filter(Boolean).join(', ') || ''], ["GSTIN No. ", renderValue(customerData === null || customerData === void 0 || (_customerData$Person3 = customerData.Person) === null || _customerData$Person3 === void 0 ? void 0 : _customerData$Person3.VatId)]], rightX - 15, rightY, 19, 20, 45);
                    doc.setDrawColor('#DEE4EB');
                    doc.setLineWidth(0.132);
                    doc.line(rightX - 18, rightY - 1, rightX - 18, customerY + 0.5);
                    doc.setLineWidth(0.264);
                    doc.setDrawColor('black');
                    // === Divider ===
                    var dividerY = Math.max(leftY, centerY, customerY) + 3;
                    otherPageStartY = dividerY + 5;
                    doc.setFont("helvetica", "bold");
                    // doc.text("GSTIN No.  :", leftX, dividerY + 2);
                    doc.setFont("helvetica", "normal");
                    doc.text('', leftX + 16, dividerY + 2);
                    doc.setLineWidth(0.132);
                    doc.line(margin, dividerY + 5, pageWidth - margin, dividerY + 5);
                    // After drawing horizontal divider
                    var sectionY = dividerY + 8;
                    var colSpacing = (pageWidth - 2 * margin) / 3;
                    // Column X positions
                    var vehicleX = margin;
                    var estimateX = margin + colSpacing;
                    var insuranceX = margin + colSpacing * 2;
                    // === VEHICLE DETAILS ===
                    var currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                    if (currentPage === 1) {
                        var _crud$installbaseDeta, _InsuranceDetails$Ins;
                        var vehicleDetailsY = renderDetails("Vehicle Details:", [["Registration No.", renderValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.RegistrationNo)], ["KM Reading", renderValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ODOMeterReading)], ["Chassis No.", renderValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.VinNo)], ["Model Name", renderValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ProductName)], ["Engine No.", renderValue((_crud$installbaseDeta = crud['installbaseDetailsById']) === null || _crud$installbaseDeta === void 0 || (_crud$installbaseDeta = _crud$installbaseDeta.data) === null || _crud$installbaseDeta === void 0 ? void 0 : _crud$installbaseDeta.EngineNo)]], vehicleX, sectionY, 20, 20, 50);
                        // === ESTIMATE DETAILS ===
                        var estimateDetailsY = renderDetails("Estimate Details:", [["Estimate No.", renderValue((vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.SourceDocumentNo) || (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.Code))], ["Date", vehicleDetails !== null && vehicleDetails !== void 0 && vehicleDetails.CreatedOn ? dayjs(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.CreatedOn).format('DD MMM, YYYY') : ''], ["Campaign", renderValue(vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.CampaignName)]], estimateX, sectionY, 20, 20, 42);
                        // === INSURANCE DETAILS ===
                        var insuranceDetailsY = renderDetails("Insurance Details:", [["Provider", renderValue(providerName)], ["Policy No.", renderValue(InsuranceDetails === null || InsuranceDetails === void 0 ? void 0 : InsuranceDetails.PolicyNumber)],
                            // ["Policy Expiry Date", InsuranceDetails?.PolicyExpiryDate ? dayjs(InsuranceDetails?.PolicyExpiryDate).format('DD MMM, YYYY') : ''],
                            ["Policy Valid Till", InsuranceDetails !== null && InsuranceDetails !== void 0 && InsuranceDetails.PolicyExpiryDate ? dayjs(InsuranceDetails === null || InsuranceDetails === void 0 ? void 0 : InsuranceDetails.PolicyExpiryDate).format('DD MMM, YYYY') : ''], ["Address", [insuranceProviderAddress === null || insuranceProviderAddress === void 0 ? void 0 : insuranceProviderAddress.Address1, insuranceProviderAddress === null || insuranceProviderAddress === void 0 ? void 0 : insuranceProviderAddress.Address2, insuranceProviderAddress === null || insuranceProviderAddress === void 0 ? void 0 : insuranceProviderAddress.Address3, insuranceProviderAddress === null || insuranceProviderAddress === void 0 ? void 0 : insuranceProviderAddress.Address4, insuranceProviderAddress === null || insuranceProviderAddress === void 0 ? void 0 : insuranceProviderAddress.CityName, insuranceProviderAddress === null || insuranceProviderAddress === void 0 ? void 0 : insuranceProviderAddress.StateName, insuranceProviderAddress === null || insuranceProviderAddress === void 0 ? void 0 : insuranceProviderAddress.Zip, insuranceProviderAddress === null || insuranceProviderAddress === void 0 ? void 0 : insuranceProviderAddress.CountryName].filter(Boolean).join(', ') || ''], ["GSTIN No.", renderValue(InsuranceDetails === null || InsuranceDetails === void 0 || (_InsuranceDetails$Ins = InsuranceDetails.InsuranceOrganization) === null || _InsuranceDetails$Ins === void 0 ? void 0 : _InsuranceDetails$Ins.TaxId)]], insuranceX, sectionY, 24, 25, 45);
                        // === Return the Y position below the deepest section ===
                        var DVY = Math.max(vehicleDetailsY, estimateDetailsY, insuranceDetailsY) + 6;
                        doc.setLineWidth(0.132);
                        doc.line(margin, DVY, pageWidth - margin, DVY);
                        return DVY + 4;
                    }
                    else {
                        return dividerY;
                    }
                };
                customerVoice = function (doc, customerVoiceStartY) {
                    var _customerComplaintLis;
                    var pageWidth = doc.internal.pageSize.getWidth();
                    var startX = 7;
                    var startY = 2 + customerVoiceStartY;
                    var lineHeight = 5;
                    var customerComplaints = (data === null || data === void 0 ? void 0 : data.CustomerVoice) || [];
                    var customerFeedback = customerComplaints.map(function (item) { return (item === null || item === void 0 ? void 0 : item.CustomerComplaint) || '-'; }).join(' ');
                    var label = "Customer Voice : ";
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    doc.text(label || '', startX, startY);
                    doc.setFont("helvetica", "normal");
                    var customerComplaintsText = ((customerComplaintList === null || customerComplaintList === void 0 || (_customerComplaintLis = customerComplaintList[0]) === null || _customerComplaintLis === void 0 ? void 0 : _customerComplaintLis.CustomerComplaint) || "").replace(/\s+/g, ' ');
                    doc.text(customerComplaintsText || '', startX + doc.getTextWidth(label) + 2, startY, {
                        maxWidth: 165
                    });
                    var labelWidth = doc.getTextWidth(label);
                    var feedbackX = startX + labelWidth;
                    var rightMargin = 15;
                    var availableWidth = pageWidth - feedbackX - rightMargin;
                    doc.setFont("helvetica", "normal");
                    var splitText = doc.splitTextToSize(customerComplaintsText, availableWidth);
                    // doc.text(splitText[0], feedbackX, startY);
                    // for (let i = 1; i < splitText.length; i++) {
                    //     doc.text(splitText[i], startX, startY + i * lineHeight);
                    // }
                    var usedHeight = splitText.length * lineHeight;
                    return startY + usedHeight;
                };
                customerVoiceStartY = addHeader(doc);
                customerVoice(doc, customerVoiceStartY);
                afterCustomerVoiceY = customerVoice(doc, customerVoiceStartY);
                totalPagesExp = "{total_pages_count_string}";
                addFooter = function (totalPages) {
                    var _AppDetails4, _documentDetailsGetBy6, _getContactDetailsDat;
                    var marginLeft = 7;
                    var marginRight = 7;
                    var contentWidth = pageWidth - marginLeft - marginRight;
                    var currentPage = doc.internal.getCurrentPageInfo().pageNumber;
                    var isLastPage = currentPage === totalPages;
                    var footerY = pageHeight - 38;
                    if (isLastPage) {
                        var _AppDetails2, _AppDetails3;
                        footerHeight = 60;
                        var TremsY_1 = pageHeight - 65;
                        doc.setFont("helvetica", "bold");
                        doc.text("Terms & Conditions:", 7, TremsY_1);
                        doc.setFont("helvetica", "normal");
                        doc.setFontSize(6);
                        var shortTerms = ["1. Vehicle kept in workshop & driven by staff at Owner's risk. Please remove all valuables", "2. Any additional repair done outside will be charged extra.", "3. All disputes are subject to jurisdiction of local court, where service & repair work is performed.", "4. Estimate prices may change without notice based on ".concat(channelName === E_Channel_Name.Triumph && (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ProductCode) != null && productCodesArray && productCodesArray.length > 0 && productCodesArray !== null && productCodesArray !== void 0 && productCodesArray.includes(vehicleDetails.ProductCode) ? 'BAL' : ((_AppDetails2 = AppDetails[channelName]) === null || _AppDetails2 === void 0 ? void 0 : _AppDetails2.OEM_Name) || 'BAL', " rates. Current spare part prices at fitment or invoicing will apply."), "5. Customers must resolve reimbursement delays or settlement disputes with the surveyor or insurer, as dealers and ".concat(channelName === E_Channel_Name.Triumph && (vehicleDetails === null || vehicleDetails === void 0 ? void 0 : vehicleDetails.ProductCode) != null && productCodesArray && productCodesArray.length > 0 && productCodesArray !== null && productCodesArray !== void 0 && productCodesArray.includes(vehicleDetails.ProductCode) ? 'BAL' : ((_AppDetails3 = AppDetails[channelName]) === null || _AppDetails3 === void 0 ? void 0 : _AppDetails3.OEM_Name) || 'BAL', " have limited control."), "6. Customers must collect “Total Loss” vehicles within 15 days of insurer’s declaration and will be charged nominal fees for damage assessment and estimates.", "7. Customers must pay applicable parking charges for delays in vehicle pickup after workshop notification."];
                        shortTerms.forEach(function (line, i) {
                            doc.text(line, 7, TremsY_1 + 3 + i * 4);
                        });
                    }
                    var qrSize = 6;
                    var spacing = 5;
                    // === QR and App Download Text ===
                    // if (qrBase64) {
                    //     doc.addImage(qrBase64, 'PNG', marginLeft, footerY + 5, qrSize, qrSize);
                    // }
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    doc.text(((_AppDetails4 = AppDetails[channelName]) === null || _AppDetails4 === void 0 ? void 0 : _AppDetails4.Info) || '', marginLeft, footerY + 8, {
                        maxWidth: 100
                    });
                    // === Inline Labels with Lines: Service Advisor and Contact ===
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(8);
                    var inlineY = footerY + 22;
                    var cursorX = marginLeft;
                    var advisorLabel = "Service Advisor";
                    doc.text(advisorLabel, cursorX, inlineY);
                    var serviceAdvisorName = documentDetailsGetById === null || documentDetailsGetById === void 0 || (_documentDetailsGetBy6 = documentDetailsGetById.data) === null || _documentDetailsGetBy6 === void 0 || (_documentDetailsGetBy6 = _documentDetailsGetBy6.AssignedEmployee) === null || _documentDetailsGetBy6 === void 0 ? void 0 : _documentDetailsGetBy6.AssignedEmployeePerson;
                    var advisorName = serviceAdvisorName ? "".concat((serviceAdvisorName === null || serviceAdvisorName === void 0 ? void 0 : serviceAdvisorName.GivenName) || '', " ").concat((serviceAdvisorName === null || serviceAdvisorName === void 0 ? void 0 : serviceAdvisorName.FamilyName) || '').trim() : " "; // NEED TO CHECK
                    var lineStartX = cursorX + doc.getTextWidth(advisorLabel) + 2;
                    var nameTextWidth = doc.getTextWidth(advisorName);
                    var nameX = lineStartX + (30 - nameTextWidth) / 2;
                    var nameY = inlineY - 1.5;
                    doc.text(advisorName || '', nameX, nameY);
                    cursorX += doc.getTextWidth(advisorLabel) + 2;
                    doc.line(cursorX, inlineY, cursorX + 30, inlineY);
                    cursorX += 35;
                    var contactLabel = "Contact";
                    doc.text(contactLabel, cursorX, inlineY);
                    cursorX += doc.getTextWidth(contactLabel) + 2;
                    var advisorNumber = (getContactDetailsData === null || getContactDetailsData === void 0 || (_getContactDetailsDat = getContactDetailsData.data) === null || _getContactDetailsDat === void 0 ? void 0 : _getContactDetailsDat.MobileNumber) || "";
                    var lineWidth = 30;
                    var textWidth = doc.getTextWidth(advisorNumber);
                    var numberX = cursorX + lineWidth / 2 - textWidth / 2;
                    var numberY = inlineY - 2;
                    doc.text(advisorNumber, numberX, numberY);
                    doc.line(cursorX, inlineY, cursorX + 30, inlineY);
                    // === Authorized Signatory ===
                    var signLineY = inlineY;
                    var signTextY = inlineY + 4;
                    var orgLineStartX = marginLeft + 140;
                    var orgLineEndX = orgLineStartX + 45;
                    doc.setFont("helvetica", "bold");
                    // doc.text(selectedBranch?.OrganizationName || '', orgLineStartX - 33, signLineY - 5, { maxWidth: 36 });
                    // Dynamically position OrganizationName for up to 3 lines, centered in the 36-width box
                    var orgName = (selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationName) || '';
                    var orgMaxWidth = 36;
                    var orgLineHeight = 3.5; // line height for org name
                    doc.setFont("helvetica", "bold");
                    doc.setFontSize(8);
                    // Split the orgName into lines that fit within orgMaxWidth
                    var orgLines = doc.splitTextToSize(orgName, orgMaxWidth);
                    // Limit to 3 lines for display
                    var orgLinesToShow = orgLines.slice(0, 3);
                    // Calculate total height of the org name block
                    var orgBlockHeight = orgLinesToShow.length * orgLineHeight;
                    // const orgBlockStartY = signLineY - 5 - orgBlockHeight / 2 + orgLineHeight / 2;
                    var orgBlockStartY;
                    if (orgLinesToShow.length === 1) {
                        orgBlockStartY = signLineY - 2;
                    }
                    else {
                        orgBlockStartY = signLineY - 4 - orgBlockHeight / 2 + orgLineHeight / 2;
                    }
                    // Center each line horizontally in the 36-width box
                    for (var i = 0; i < orgLinesToShow.length; i++) {
                        var line = orgLinesToShow[i];
                        var lineWidth_1 = doc.getTextWidth(line);
                        // Center in the 36-width box, which starts at (orgLineStartX - 33)
                        var orgBoxCenterX = orgLineStartX - 33 + orgMaxWidth / 2;
                        var lineX = orgBoxCenterX - lineWidth_1 / 2;
                        var lineY = orgBlockStartY + i * orgLineHeight;
                        doc.text(line || '', lineX, lineY);
                    }
                    doc.line(orgLineStartX - 35, signLineY, orgLineEndX - 40, signLineY);
                    doc.setFont("helvetica", "normal");
                    doc.setFontSize(6);
                    var signatoryLabel = "Authorized Signatory";
                    var signatoryLabelWidth = doc.getTextWidth(signatoryLabel);
                    var signatoryCenterX = (orgLineStartX + orgLineEndX) / 2;
                    doc.text(signatoryLabel, signatoryCenterX - signatoryLabelWidth / 2 - 35, signTextY - 1);
                    // === Customer Signature ===
                    var custLineStartX = pageWidth - marginRight - 45;
                    var custLineEndX = custLineStartX + 40;
                    if (inPersonImage || signature) {
                        doc.addImage(inPersonImage || signature, 'PNG', custLineStartX + 10, signLineY - 10, 15, 7);
                    }
                    doc.line(custLineStartX, signLineY, custLineEndX, signLineY);
                    var customerLabel = "Sign of Customer";
                    var customerLabelWidth = doc.getTextWidth(customerLabel);
                    var customerCenterX = (custLineStartX + custLineEndX) / 2;
                    doc.text(customerLabel, customerCenterX - customerLabelWidth / 2, signTextY - 1);
                    // === Bottom Line ===
                    var bottomY = pageHeight - 11;
                    doc.setDrawColor(0);
                    doc.setLineWidth(0.132);
                    doc.line(marginLeft, bottomY, pageWidth - marginRight, bottomY);
                    // === Printed Date & Page No. ===
                    var printY = pageHeight - 7;
                    doc.setFontSize(8);
                    doc.setTextColor(0, 0, 0);
                    doc.text("Printed On: ".concat(formattedDate, " ").concat(formattedTime), marginLeft, printY);
                    doc.text("Page ".concat(currentPage, " of ").concat(totalPagesExp), pageWidth - marginRight - 17, printY);
                };
                renderUnifiedTable = function (_ref3) {
                    var type = _ref3.type, title = _ref3.title, data = _ref3.data, columns = _ref3.columns, startY = _ref3.startY, groupedHead = _ref3.groupedHead, _a = _ref3.tableWidth, tableWidth = _a === void 0 ? pageWidth - 20 : _a, _b = _ref3.margingLeft, margingLeft = _b === void 0 ? 10 : _b;
                    var formattedData = (data === null || data === void 0 ? void 0 : data.map(function (row, index) {
                        var _row$srNo, _row$Description;
                        return _objectSpread(_objectSpread({
                            srNo: (_row$srNo = row === null || row === void 0 ? void 0 : row.srNo) !== null && _row$srNo !== void 0 ? _row$srNo : index + 1
                        }, row), {}, {
                            partCodeName: "".concat((row === null || row === void 0 ? void 0 : row.Code) || '', " - ").concat((row === null || row === void 0 ? void 0 : row.ChildName) || ''),
                            labourCodeName: "".concat((row === null || row === void 0 ? void 0 : row.Code) || '', " - ").concat((row === null || row === void 0 ? void 0 : row.ChildName) || ''),
                            Description: row !== null && row !== void 0 && (_row$Description = row.Description) !== null && _row$Description !== void 0 && _row$Description.trim() ? row.Description : '-'
                        });
                    })) || [];
                    var totalRow = columns === null || columns === void 0 ? void 0 : columns.reduce(function (totals, col) {
                        if (['summary', 'billing'].includes(type))
                            return totals;
                        if (['discountAmount', 'TaxableAmount', 'CGSTAmount', 'SGSTAmount', 'Amount', 'Rate', 'Quantity'].includes(col.field)) {
                            totals[col.field] = data === null || data === void 0 ? void 0 : data.reduce(function (sum, row) { return sum + (Number(row[col.field]) || 0); }, 0).toFixed(2);
                        }
                        else if (['igst', 'sgstUtGst', 'cgsT', 'cgst', 'sgstUtgs'].includes(col.field)) {
                            totals[col.field] = "1";
                        }
                        return totals;
                    }, {});
                    if (['labour', 'parts'].includes(type)) {
                        formattedData === null || formattedData === void 0 || formattedData.push(_objectSpread({
                            srNo: ''
                        }, totalRow));
                    }
                    if (['summary', 'billing'].includes(type)) {
                        if (Array.isArray(data)) {
                            data === null || data === void 0 || data.forEach(function (row) {
                                row.totalPartAmount = Number(row.totalPartAmount || 0).toFixed(2);
                                row.totalLabourAmount = Number(row.totalLabourAmount || 0).toFixed(2);
                                row.Total = (Number(row.totalPartAmount || 0) + Number(row.totalLabourAmount || 0)).toFixed(2);
                            });
                        }
                        var totalRowSummary = {
                            Section: "Grand Total",
                            totalPartAmount: data === null || data === void 0 ? void 0 : data.reduce(function (sum, row) { return sum + (Number(row.totalPartAmount) || 0); }, 0).toFixed(2),
                            totalLabourAmount: data === null || data === void 0 ? void 0 : data.reduce(function (sum, row) { return sum + (Number(row.totalLabourAmount) || 0); }, 0).toFixed(2),
                            Total: data === null || data === void 0 ? void 0 : data.reduce(function (sum, row) { return sum + (Number(row.totalPartAmount || 0) + Number(row.totalLabourAmount || 0)); }, 0).toFixed(2)
                        };
                        data === null || data === void 0 || data.push(totalRowSummary);
                    }
                    var bodyData = type === 'summary' || type === 'billing' ? data === null || data === void 0 ? void 0 : data.map(function (row) {
                        var _Number, _Number2, _Number3;
                        return [row.Section, (_Number = Number(row.totalPartAmount)) === null || _Number === void 0 ? void 0 : _Number.toLocaleString("en-IN", {
                                minimumFractionDigits: 2
                            }), (_Number2 = Number(row.totalLabourAmount)) === null || _Number2 === void 0 ? void 0 : _Number2.toLocaleString("en-IN", {
                                minimumFractionDigits: 2
                            }), (_Number3 = Number(row.Total)) === null || _Number3 === void 0 ? void 0 : _Number3.toLocaleString("en-IN", {
                                minimumFractionDigits: 2
                            })];
                    }) : formattedData === null || formattedData === void 0 ? void 0 : formattedData.map(function (row) { return columns.map(function (col) { return row[col.field]; }); });
                    doc.setFont('helvetica', 'normal');
                    doc.setFontSize(8);
                    if (title) {
                        doc.setFontSize(8);
                        doc.setFont('helvetica', 'bold');
                        doc.text(title, margingLeft, startY - (type === 'summary' || type === 'billing' ? -8 : 10));
                    }
                    autoTable(doc, {
                        head: groupedHead || [columns.map(function (col) { return col.header; })],
                        body: bodyData,
                        startY: startY + (type === 'summary' || type === 'billing' ? 10 : 0),
                        margin: {
                            top: headerHeight - 1,
                            bottom: footerHeight - 3,
                            left: margingLeft,
                            right: 13
                        },
                        styles: {
                            font: 'Roboto',
                            fontSize: 8,
                            cellPadding: 1,
                            lineColor: [0, 0, 0],
                            lineWidth: 0.2
                        },
                        headStyles: {
                            fillColor: false,
                            textColor: 0,
                            fontSize: 8,
                            fontStyle: "bold",
                            lineColor: [0, 0, 0],
                            lineWidth: 0.2
                        },
                        bodyStyles: {
                            textColor: 0,
                            lineColor: [0, 0, 0],
                            lineWidth: 0.2
                        },
                        theme: "grid",
                        tableWidth: tableWidth,
                        didDrawPage: function () {
                            doc.setFont("helvetica", "normal");
                            addHeader(doc);
                            var totalPages = doc.internal.pages.length;
                            addFooter(totalPages);
                        },
                        didParseCell: function (data) {
                            var _data$row;
                            if (!(data !== null && data !== void 0 && data.row) || !(data !== null && data !== void 0 && data.cell) || !(data !== null && data !== void 0 && data.column))
                                return;
                            var isLastRow = (data === null || data === void 0 || (_data$row = data.row) === null || _data$row === void 0 ? void 0 : _data$row.index) === (bodyData === null || bodyData === void 0 ? void 0 : bodyData.length) - 1;
                            if (isLastRow) {
                                data.cell.styles.fontStyle = 'bold';
                                if (type === 'labour' && data.column.index === 0) {
                                    data.cell.colSpan = 5;
                                    data.cell.text = ['Total'];
                                    data.cell.styles.halign = 'center';
                                }
                                if (type === 'labour' && data.column.index > 0 && data.column.index < 5) {
                                    data.cell.colSpan = 0;
                                    data.cell.text = [''];
                                }
                                if (type === 'parts' && data.column.index === 0) {
                                    data.cell.colSpan = 4;
                                    data.cell.text = ['Total'];
                                    data.cell.styles.halign = 'center';
                                }
                                if (type === 'parts' && data.column.index > 0 && data.column.index < 4) {
                                    data.cell.colSpan = 0;
                                    data.cell.text = [''];
                                }
                            }
                            if ((type === 'summary' || type === 'billing') && [1, 2, 3].includes(data === null || data === void 0 ? void 0 : data.column.index)) {
                                data.cell.styles.halign = 'left';
                            }
                        }
                    });
                };
                renderTable = function (_ref4) {
                    var _a;
                    var _ref5;
                    var title = _ref4.title, data = _ref4.data, columns = _ref4.columns, groupedHead = _ref4.groupedHead, startY = _ref4.startY, _b = _ref4.customColumnWidths, customColumnWidths = _b === void 0 ? {} : _b, tableWidth = _ref4.tableWidth, _c = _ref4.marginLeft, marginLeft = _c === void 0 ? 10 : _c, _d = _ref4.isDoubleTable, isDoubleTable = _d === void 0 ? false : _d, emptyColumnIndex = _ref4.emptyColumnIndex, _e = _ref4.marginTop, marginTop = _e === void 0 ? headerHeight : _e, _f = _ref4.marginBottom, marginBottom = _f === void 0 ? footerHeight : _f, _g = _ref4.isHideTotalRow, isHideTotalRow = _g === void 0 ? false : _g, _h = _ref4.startColumnName, startColumnName = _h === void 0 ? 'srNo' : _h;
                    var formattedData = data === null || data === void 0 ? void 0 : data.map(function (row, index) { return _objectSpread({
                        srNo: index + 1
                    }, row); });
                    var totalRow = columns === null || columns === void 0 ? void 0 : columns.reduce(function (totals, col) {
                        if (['Quantity', 'TaxableAmount', 'SGSTAmount', 'CGSTAmount', 'IGSTAmount', 'Amount', 'totalPartAmount', 'totalLabourAmount', 'total'].includes(col.field)) {
                            totals[col.field] = data.reduce(function (sum, row) {
                                var value = parseFloat(row[col.field]);
                                return sum + (isNaN(value) ? 0 : value);
                            }, 0).toFixed(2);
                        }
                        else if (col.field === '') {
                            totals[col.field] = '';
                        }
                        else if (col.field === startColumnName) {
                            totals[col.field] = startColumnName === 'srNo' ? 'Total' : 'Grand Total';
                        }
                        else {
                            totals[col.field] = '';
                        }
                        return totals;
                    }, {});
                    formattedData === null || formattedData === void 0 || formattedData.push(_objectSpread({
                        startColumnName: startColumnName === 'srNo' ? 'Total' : 'Grand Total'
                    }, totalRow));
                    doc.setFontSize(8);
                    doc.setFont("helvetica", "bold");
                    // doc.text(title, marginLeft, (doc.internal as any).getNumberOfPages() === 1 ? startY + 22 : startY + 7);
                    doc.text(title || '', marginLeft, startY);
                    var totalPagesFinal = 0;
                    autoTable(doc, {
                        head: groupedHead || [columns.map(function (col) { return col.header; })],
                        body: (_ref5 = isHideTotalRow ? data : formattedData) === null || _ref5 === void 0 ? void 0 : _ref5.map(function (row) { return columns === null || columns === void 0 ? void 0 : columns.map(function (col) { return row[col.field]; }); }),
                        // startY: (doc.internal as any).getNumberOfPages() === 1 ? startY + 25 : startY + 10,
                        startY: startY + 3,
                        margin: {
                            top: marginTop,
                            bottom: marginBottom,
                            left: marginLeft
                        },
                        styles: {
                            font: 'Roboto',
                            fontSize: 7,
                            cellPadding: 1,
                            lineColor: [0, 0, 0],
                            overflow: 'linebreak',
                            lineWidth: 0.2
                        },
                        headStyles: {
                            fillColor: false,
                            textColor: 0,
                            fontSize: 7,
                            fontStyle: "bold"
                        },
                        bodyStyles: {
                            textColor: 0
                        },
                        columnStyles: _objectSpread(_objectSpread({}, customColumnWidths || {}), emptyColumnIndex !== undefined ? (_a = {},
                            _a[emptyColumnIndex] = {
                                cellWidth: 2,
                                lineWidth: {
                                    top: 0,
                                    bottom: 0
                                }
                            },
                            _a) : {}),
                        theme: "grid",
                        tableWidth: tableWidth,
                        didDrawPage: function (data) {
                            var doc = data.doc;
                            var pageNumber = doc.internal.getCurrentPageInfo().pageNumber;
                            totalPagesFinal = doc.internal.getNumberOfPages();
                            var table = data.table;
                            // if (pageNumber === 1) {
                            if (pageNumber !== 1) {
                                addHeader(doc);
                            }
                            addFooter(doc);
                            // } else {
                            //     addOtherPagesHeader(doc)
                            //     addOtherPageFooter(doc);
                            // }
                            // table.settings.margin.left = 7;
                            // table.settings.margin.right = 7;
                            // table.settings.tableWidth = pageWidth - 14;
                        },
                        didParseCell: function (data) {
                            if (data.row && data.row.section === 'body' && data.row.raw && (data.row.raw[0] === 'Grand Total' || data.row.raw[0] === 'Total')) {
                                var _data$column, _data$row2;
                                data.cell.styles.fontStyle = 'bold';
                                if ((data === null || data === void 0 || (_data$column = data.column) === null || _data$column === void 0 ? void 0 : _data$column.index) === 1 && (data === null || data === void 0 || (_data$row2 = data.row) === null || _data$row2 === void 0 ? void 0 : _data$row2.raw[0]) === 'Total') {
                                    var _data$row3;
                                    var startIndex = (data === null || data === void 0 || (_data$row3 = data.row) === null || _data$row3 === void 0 || (_data$row3 = _data$row3.raw) === null || _data$row3 === void 0 ? void 0 : _data$row3.indexOf("Total")) + 1;
                                    var count = 0;
                                    for (var i = startIndex; i < (data === null || data === void 0 || (_data$row4 = data.row) === null || _data$row4 === void 0 || (_data$row4 = _data$row4.raw) === null || _data$row4 === void 0 ? void 0 : _data$row4.length); i++) {
                                        var _data$row4, _data$row5;
                                        if ((data === null || data === void 0 || (_data$row5 = data.row) === null || _data$row5 === void 0 ? void 0 : _data$row5.raw[i]) === "") {
                                            count++;
                                        }
                                        else {
                                            break;
                                        }
                                    }
                                    data.cell.colSpan = count;
                                }
                            }
                            if (isDoubleTable) {
                                if ((data.section === 'body' || data.section === 'head') && data.column.index === 5) {
                                    data.cell.styles.lineWidth = {
                                        top: 0,
                                        bottom: 0,
                                        left: 0.26,
                                        right: 0
                                    };
                                }
                                if (data.section === 'body' && data.column.index === 4) {
                                    data.cell.styles.lineWidth = 0.2;
                                    data.cell.styles.lineColor = [0, 0, 0];
                                }
                            }
                        }
                    });
                };
                finalY = (_lastAutoTable = doc.lastAutoTable) === null || _lastAutoTable === void 0 ? void 0 : _lastAutoTable.finalY;
                if (finalY) {
                    tableBottomY = finalY;
                }
                _a = getLabourColumnsAndHead(taxMode), labourColumns = _a.labourColumns, labourGroupedHead = _a.labourGroupedHead;
                // const afterCustomerVoiceY = customerVoice(doc, customerVoiceStartY);
                renderTable({
                    title: "Labour :",
                    data: extractFormattedPartAndLabours(allLabours, Type_Enum.Labour),
                    columns: labourColumns,
                    startY: afterCustomerVoiceY,
                    tableWidth: pageWidth - leftMargin - 7,
                    groupedHead: labourGroupedHead,
                    marginLeft: 7,
                    customColumnWidths: {
                        0: {
                            halign: 'center'
                        },
                        2: {
                            cellWidth: 35
                        },
                        4: {
                            halign: 'center'
                        },
                        5: {
                            halign: 'center'
                        },
                        // 6: { halign: 'center' },
                        6: {
                            halign: 'center',
                            cellWidth: 10
                        },
                        7: {
                            halign: 'center'
                        },
                        8: {
                            cellWidth: 15,
                            halign: 'center'
                        },
                        9: {
                            halign: 'center'
                        },
                        10: {
                            halign: 'center'
                        },
                        11: {
                            halign: 'center'
                        },
                        12: {
                            halign: 'center'
                        },
                        13: {
                            halign: 'center'
                        },
                        14: {
                            halign: 'center'
                        },
                        15: {
                            halign: 'center'
                        }
                    }
                });
                labourTableY = doc.lastAutoTable.finalY;
                doc.text('Note : ', 7, labourTableY + 4);
                doc.setFontSize(6.5);
                doc.setFont("helvetica", "normal");
                doc.text('1 Unit = 15  Minutes', 15, labourTableY + 4);
                _b = getPartsColumnsAndHead(taxMode), partsColumns = _b.partsColumns, partGroupedHead = _b.partGroupedHead;
                renderTable({
                    title: "Parts :",
                    data: extractFormattedPartAndLabours(allParts, Type_Enum.Parts),
                    columns: partsColumns,
                    startY: labourTableY + 10,
                    tableWidth: pageWidth - leftMargin - 7,
                    groupedHead: partGroupedHead,
                    marginLeft: 7,
                    customColumnWidths: {
                        0: {
                            halign: 'center'
                        },
                        3: {
                            halign: 'center'
                        },
                        4: {
                            halign: 'center'
                        },
                        5: {
                            halign: 'center'
                        },
                        6: {
                            halign: 'center',
                            cellWidth: 10
                        },
                        7: {
                            halign: 'center'
                        },
                        8: {
                            cellWidth: 15,
                            halign: 'center'
                        },
                        9: {
                            halign: 'center'
                        },
                        10: {
                            halign: 'center'
                        },
                        11: {
                            halign: 'center'
                        },
                        12: {
                            halign: 'center'
                        },
                        13: {
                            halign: 'center'
                        },
                        14: {
                            halign: 'center'
                        },
                        15: {
                            halign: 'center'
                        }
                    }
                });
                partTableY = doc.lastAutoTable.finalY;
                availableSpace = pageHeight - partTableY - footerHeight;
                if (availableSpace > 100) {
                    renderTable({
                        title: "Estimation Summary :",
                        data: estimationSummary,
                        columns: estimateColumns,
                        startY: partTableY + 5,
                        tableWidth: pageWidth / 2 - 9,
                        marginLeft: 7,
                        startColumnName: 'Section',
                        customColumnWidths: {
                            1: {
                                halign: 'center'
                            },
                            2: {
                                halign: 'center'
                            },
                            3: {
                                halign: 'center'
                            }
                        }
                    });
                    renderTable({
                        title: "Estimated Billing Summary : ",
                        data: estimateBillingSummary,
                        columns: estimateBillingColumns,
                        startY: partTableY + 5,
                        tableWidth: pageWidth / 2 - 9,
                        marginLeft: pageWidth / 2 + 2,
                        startColumnName: 'Section',
                        customColumnWidths: {
                            1: {
                                halign: 'center'
                            },
                            2: {
                                halign: 'center'
                            },
                            3: {
                                halign: 'center'
                            }
                        }
                    });
                }
                else {
                    startY = otherPageStartY + 6;
                    doc.addPage();
                    renderTable({
                        title: "Estimation Summary :",
                        data: estimationSummary,
                        columns: estimateColumns,
                        startY: startY,
                        tableWidth: pageWidth / 2 - 13,
                        marginLeft: 7,
                        startColumnName: 'Section',
                        customColumnWidths: {
                            1: {
                                halign: 'center'
                            },
                            2: {
                                halign: 'center'
                            },
                            3: {
                                halign: 'center'
                            }
                        }
                    });
                    renderTable({
                        title: "Estimated Billing Summary :",
                        data: estimateBillingSummary,
                        columns: estimateBillingColumns,
                        startY: startY,
                        tableWidth: pageWidth / 2 - 13,
                        marginLeft: pageWidth / 2 + 2,
                        startColumnName: 'Section',
                        customColumnWidths: {
                            1: {
                                halign: 'center'
                            },
                            2: {
                                halign: 'center'
                            },
                            3: {
                                halign: 'center'
                            }
                        }
                    });
                }
                estimateTableY = doc.lastAutoTable.finalY + 10;
                totalPages = doc.internal.getNumberOfPages();
                for (i = 1; i <= totalPages; i++) {
                    doc.setPage(i);
                    addFooter(totalPages);
                }
                if (typeof doc.putTotalPages === 'function') {
                    doc.putTotalPages(totalPagesExp);
                }
                if (mode === 'download') {
                    doc.save('ServiceEstimatePrint.pdf');
                }
                else if (mode === 'print') {
                    isMobile_1 = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
                    pdfBlob = doc.output('blob');
                    blobUrl = URL.createObjectURL(pdfBlob);
                    if (isMobile_1) {
                        newWindow = window.open(blobUrl);
                        if (newWindow) {
                            newWindow.focus();
                        }
                    }
                    else {
                        iframe_1 = document.createElement('iframe');
                        iframe_1.style.display = 'none';
                        iframe_1.src = blobUrl;
                        document.body.appendChild(iframe_1);
                        iframe_1.onload = function () {
                            var _iframe$contentWindow, _iframe$contentWindow2;
                            (_iframe$contentWindow = iframe_1.contentWindow) === null || _iframe$contentWindow === void 0 || _iframe$contentWindow.focus();
                            (_iframe$contentWindow2 = iframe_1.contentWindow) === null || _iframe$contentWindow2 === void 0 || _iframe$contentWindow2.print();
                        };
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    var formData = [{
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            spacing: 0,
            rowGap: '20px',
            elements: [{
                    type: FormItemTypes.ContainerItem,
                    name: '',
                    display: 'flex',
                    justifyContent: 'space-between',
                    columnSize: 12,
                    spacing: 0,
                    elements: [{
                            type: FormItemTypes.Typography,
                            name: '',
                            children: 'ServiceEstimatePrint.pdf',
                            columnSize: 0,
                            fontSize: 'xl',
                            fontWeight: 'strong'
                        }, {
                            type: FormItemTypes.IconButton,
                            name: '',
                            children: /*#__PURE__*/ React.createElement(CloseIcon, {
                                fontSize: "small",
                                color: "secondary"
                            }),
                            columnSize: 0,
                            onClick: function () {
                                onClose();
                            },
                            size: 'small',
                            color: 'secondary'
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: '',
            columnSize: 12,
            gap: 1.5,
            flexDirection: isMobile ? 'column' : 'row',
            justifyContent: 'end',
            spacing: 0,
            sx: {
                paddingTop: '24px'
            },
            elements: [{
                    type: FormItemTypes.Button,
                    name: '',
                    children: isPrintLoading ? /*#__PURE__*/ React.createElement(CircularProgress, {
                        size: 20
                    }) : 'Download',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'outlined',
                    onClick: function () {
                        generatePDF('download');
                    },
                    color: 'primary',
                    disabled: isPrintLoading
                }, {
                    type: FormItemTypes.Button,
                    name: '',
                    children: isPrintLoading ? /*#__PURE__*/ React.createElement(CircularProgress, {
                        color: 'inherit',
                        size: 20
                    }) : 'Print',
                    onClick: function () {
                        generatePDF('print');
                    },
                    color: 'primary',
                    columnSize: 0,
                    fullWidth: true,
                    variant: 'contained',
                    disabled: isPrintLoading
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Dialog, {
        open: open,
        onClose: onClose
    }, /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: formData,
        gridProps: {
            p: 2,
            gap: 2,
            spacing: 0
        }
    })));
};
